import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TEventReplayRestrictionPayload } from '../../../../../shared/frontend/scripts/services/commonApiService';
import {
  TCreateEventCollectionParams,
  TEditEventCollectionParams,
  TEventBracketDungeonPayload,
  TEventBracketMatchGamePayload,
  TEventBracketMatchPayload
} from '../../../../../shared/frontend/scripts/services/commonApiService';
import {
  TEventBracketPayload,
  TEventSpecRestrictionPayload
} from '../../../../../shared/frontend/scripts/services/commonApiService';
import {
  TAddEventVideoParams,
  TAddEventWinnerParams,
  TBatchUpdateBracketTeamsPayload,
  TDeleteEventCollectionParams,
  TEditCollectionWinnerParams,
  TEditEventVideoParams,
  TEditEventWinnerParams,
  TGetEventCollectionDetailsParams,
  TGetEventCollectionListParams,
  TGetEventListDataParams,
  TRemoveCollectionWinnerParams,
  TRemoveEventVideoParams,
  TRemoveEventWinnerParams,
  TUpdateEventVideosParams,
  TUpdateBracketTeamPayload
} from '../../../../../shared/frontend/scripts/services/commonApiService';
import { TAddCollectionWinnerParams } from '../../../../../shared/frontend/scripts/services/commonApiService';
import { TEventBodyPayload } from '../../../../../shared/frontend/scripts/services/commonApiService';
import {
  TEventBracketDetailsManagementState,
  TEventBracketDetailsPreviewState,
  TEventBracketListManagementState,
  TEventBracketMatchDetailsState,
  TEventBracketMatchesState,
  TEventBracketMatchGameDetailsState,
  TEventBracketMatchGamesState,
  TEventBracketTeamListState,
  TEventCollectionDetailsState,
  TEventRegistrationStaticDataState,
  TEventsManagementState
} from '../../../../../shared/frontend/scripts/event-management/store/types';
import { TEventDetailsState } from '../../../../../shared/frontend/scripts/event-management/store/types';
import { TEventVideosListState } from '../../../../../shared/frontend/scripts/event-management/store/types';
import { TEventCollectionListState } from '../../../../../shared/frontend/scripts/event-management/store/types';
import { TEventListState } from '../../../../../shared/frontend/scripts/event-management/store/types';
import {
  IEventCollaboratorSummary,
  TGetEventVideosQueryParams,
  TLegacyEventParams
} from '../../../../../shared/types/eventTypes';
import { IEventBracketTeamDetails } from '../../../../../shared/types/eventBracketTypes';
import { TGetBracketTeamListFilters } from '../../../../../shared/types/eventBracketTypes';

const getInitialState = (): TEventsManagementState => ({
  eventList: {
    isLoading: false,
    isLoaded: false,
    list: [],
    ui: {},
    meta: {}
  },

  eventDetails: {
    isLoading: false,
    isLoaded: false,
    details: null,
    ui: {},
    collaborators: [],
    collections: [],
    brackets: []
  },

  eventCollectionList: {
    isLoaded: false,
    isLoading: false,
    list: [],
    ui: {}
  },

  eventCollectionDetails: {
    isLoading: false,
    isLoaded: false,
    details: null,
    ui: {}
  },

  eventRegistrationStaticData: {
    isLoading: false,
    isLoaded: false,
    data: {
      registrationStepOptionModes: [],
      registrationSteps: []
    }
  },
  eventBracketList: {
    isLoading: false,
    isRefreshing: false,
    isLoaded: false,
    list: [],
    ui: {}
  },
  eventBracketDetails: {
    isLoading: false,
    isLoaded: false,
    details: null,
    ui: {}
  },
  eventBracketTeamList: {
    isLoading: false,
    isRefreshing: false,
    isLoaded: false,
    list: [],
    ui: {
      count: 0,
      page: 0,
      pageSize: 0
    }
  },
  eventBracketMatches: {
    isLoading: false,
    isRefreshing: false,
    isLoaded: false,
    matches: [],
    ui: {}
  },
  eventBracketMatchDetails: {
    isLoading: false,
    isRefreshing: false,
    isLoaded: false,
    details: null,
    ui: {}
  },
  eventBracketPreviewDetails: {
    details: null,
    isLoading: false,
    isLoaded: false,
    isRefreshing: false
  },
  eventBracketMatchGames: {
    isLoading: false,
    isRefreshing: false,
    isLoaded: false,
    games: [],
    ui: {}
  },
  eventBracketMatchGameDetails: {
    isLoading: false,
    isRefreshing: false,
    isLoaded: false,
    details: null,
    ui: {}
  },
  eventVideosList: {
    isLoading: false,
    isLoaded: false,
    list: [],
    ui: {},
    isUpdating: false
  },
  editBracketTeam: null,
  requestPending: false
});

// Action Types
const GET_EVENT_LIST = 'EVENTS_MANAGEMENT/GET_EVENT_LIST';
const GET_EVENT_DETAILS = 'EVENTS_MANAGEMENT/GET_EVENT_DETAILS';
const GET_EVENT_COLLECTION_LIST = 'EVENTS_MANAGEMENT/GET_EVENT_COLLECTION_LIST';
const GET_EVENT_COLLECTION_DETAILS = 'EVENTS_MANAGEMENT/GET_EVENT_COLLECTION_DETAILS';
const GET_EVENT_REGISTRATION_STATIC_DATA = 'EVENTS_MANAGEMENT/GET_EVENT_REGISTRATION_STATIC_DATA';
const GET_EVENT_BRACKET_LIST = 'EVENTS_MANAGEMENT/GET_EVENT_BRACKET_LIST';
const GET_EVENT_BRACKET_DETAILS = 'EVENTS_MANAGEMENT/GET_EVENT_BRACKET_DETAILS';
const GET_EVENT_BRACKET_PREVIEW_DETAILS = 'EVENTS_MANAGEMENT/GET_EVENT_BRACKET_PREVIEW_DETAILS';
const GET_EVENT_BRACKET_TEAM_LIST = 'EVENTS_MANAGEMENT/GET_EVENT_BRACKET_TEAM_LIST';
const GET_EVENT_BRACKET_MATCHES = 'EVENTS_MANAGEMENT/GET_EVENT_BRACKET_MATCHES';
const GET_EVENT_BRACKET_MATCH_DETAILS = 'EVENTS_MANAGEMENT/GET_EVENT_BRACKET_MATCH_DETAILS';
const GET_EVENT_BRACKET_MATCH_GAMES = 'EVENTS_MANAGEMENT/GET_EVENT_BRACKET_MATCH_GAMES';
const GET_EVENT_BRACKET_MATCH_GAME_DETAILS = 'EVENTS_MANAGEMENT/GET_EVENT_BRACKET_MATCH_GAME_DETAILS';

const REFRESH_EVENT_BRACKET_LIST = 'EVENTS_MANAGEMENT/REFRESH_EVENT_BRACKET_LIST';
const REFRESH_EVENT_BRACKET_TEAM_LIST = 'EVENTS_MANAGEMENT/REFRESH_EVENT_BRACKET_TEAM_LIST';
const REFRESH_EVENT_BRACKET_PREVIEW_DETAILS = 'EVENTS_MANAGEMENT/REFRESH_EVENT_BRACKET_PREVIEW_DETAILS';
const REFRESH_EVENT_BRACKET_MATCHES = 'EVENTS_MANAGEMENT/REFRESH_EVENT_BRACKET_MATCHES';
const REFRESH_EVENT_BRACKET_MATCH_DETAILS = 'EVENTS_MANAGEMENT/REFRESH_EVENT_BRACKET_MATCH_DETAILS';
const REFRESH_EVENT_BRACKET_MATCH_GAMES = 'EVENTS_MANAGEMENT/REFRESH_EVENT_BRACKET_MATCH_GAMES';
const REFRESH_EVENT_BRACKET_MATCH_GAME_DETAILS = 'EVENTS_MANAGEMENT/REFRESH_EVENT_BRACKET_MATCH_GAME_DETAILS';

const CREATE_EVENT = 'EVENTS_MANAGEMENT/CREATE_EVENT';
const CREATE_LEGACY_EVENT = 'EVENTS_MANAGEMENT/CREATE_LEGACY_EVENT';
const EDIT_EVENT = 'EVENTS_MANAGEMENT/EDIT_EVENT';
const EDIT_LEGACY_EVENT = 'EVENTS_MANAGEMENT/EDIT_LEGACY_EVENT';
const REMOVE_EVENT = 'EVENTS_MANAGEMENT/REMOVE_EVENT';
const TOGGLE_LOCK_EVENT = 'EVENTS_MANAGEMENT/TOGGLE_LOCK_EVENT';
const COPY_EVENT = 'EVENTS_MANAGEMENT/COPY_EVENT';
const ADD_EVENT_COLLABORATOR = 'EVENTS_MANAGEMENT/ADD_EVENT_COLLABORATOR';
const REMOVE_EVENT_COLLABORATOR = 'EVENTS_MANAGEMENT/REMOVE_EVENT_COLLABORATOR';
const ADD_BRACKET_SPEC_RESTRICTION = 'EVENTS_MANAGEMENT/ADD_BRACKET_SPEC_RESTRICTION';
const REMOVE_BRACKET_SPEC_RESTRICTION = 'EVENTS_MANAGEMENT/REMOVE_BRACKET_SPEC_RESTRICTION';
const ADD_BRACKET_REPLAY_RESTRICTION = 'EVENTS_MANAGEMENT/ADD_BRACKET_REPLAY_RESTRICTION';
const REMOVE_BRACKET_REPLAY_RESTRICTION = 'EVENTS_MANAGEMENT/REMOVE_BRACKET_REPLAY_RESTRICTION';
const ADD_EVENT_VIDEO = 'EVENTS_MANAGEMENT/ADD_EVENT_VIDEO';
const EDIT_EVENT_VIDEO = 'EVENTS_MANAGEMENT/EDIT_EVENT_VIDEO';
const UPDATE_EVENT_VIDEOS = 'EVENTS_MANAGEMENT/UPDATE_EVENT_VIDEOS';
const UPDATE_EVENT_VIDEOS_LIST_STATE = 'EVENTS_MANAGEMENT/UPDATE_EVENT_VIDEOS_LIST_STATE';
const SET_EVENT_VIDEOS_LIST_STATE = 'EVENTS_MANAGEMENT/SET_EVENT_VIDEOS_LIST_STATE';
const GET_EVENT_VIDEOS = 'EVENTS_MANAGEMENT/GET_EVENT_VIDEOS';
const REMOVE_EVENT_VIDEO = 'EVENTS_MANAGEMENT/REMOVE_EVENT_VIDEO';
const UNLINK_FINAL_EVENT_VIDEO = 'EVENTS_MANAGEMENT/UNLINK_FINAL_EVENT_VIDEO';
const ADD_EVENT_TO_EVENT_COLLECTION = 'EVENTS_MANAGEMENT/ADD_EVENT_TO_EVENT_COLLECTION';
const REMOVE_EVENT_FROM_EVENT_COLLECTION = 'EVENTS_MANAGEMENT/REMOVE_EVENT_FROM_EVENT_COLLECTION';
const ADD_MULTIPLE_EVENTS_TO_EVENT_COLLECTION = 'EVENTS_MANAGEMENT/ADD_MULTIPLE_EVENTS_TO_EVENT_COLLECTION';
const REMOVE_MULTIPLE_EVENTS_FROM_EVENT_COLLECTION = 'EVENTS_MANAGEMENT/REMOVE_MULTIPLE_EVENTS_FROM_EVENT_COLLECTION';
const CREATE_EVENT_COLLECTION = 'EVENTS_MANAGEMENT/CREATE_EVENT_COLLECTION';
const DELETE_EVENT_COLLECTION = 'EVENTS_MANAGEMENT/DELETE_EVENT_COLLECTION';
const EDIT_EVENT_COLLECTION = 'EVENTS_MANAGEMENT/EDIT_EVENT_COLLECTION';
const ADD_COLLECTION_WINNER = 'EVENTS_MANAGEMENT/ADD_COLLECTION_WINNER';
const EDIT_COLLECTION_WINNER = 'EVENTS_MANAGEMENT/EDIT_COLLECTION_WINNER';
const REMOVE_COLLECTION_WINNER = 'EVENTS_MANAGEMENT/REMOVE_COLLECTION_WINNER';
const ADD_EVENT_WINNER = 'EVENTS_MANAGEMENT/ADD_EVENT_WINNER';
const EDIT_EVENT_WINNER = 'EVENTS_MANAGEMENT/EDIT_EVENT_WINNER';
const REMOVE_EVENT_WINNER = 'EVENTS_MANAGEMENT/REMOVE_EVENT_WINNER';
const CREATE_EVENT_BRACKET = 'EVENTS_MANAGEMENT/CREATE_EVENT_BRACKET';
const EDIT_EVENT_BRACKET = 'EVENTS_MANAGEMENT/EDIT_EVENT_BRACKET';
const REMOVE_EVENT_BRACKET = 'EVENTS_MANAGEMENT/REMOVE_EVENT_BRACKET';
const COPY_EVENT_BRACKET = 'EVENTS_MANAGEMENT/COPY_EVENT_BRACKET';
const ADD_EVENT_BRACKET_DUNGEON = 'EVENTS_MANAGEMENT/ADD_EVENT_BRACKET_DUNGEON';
const ADD_EVENT_BRACKET_DUNGEONS = 'EVENTS_MANAGEMENT/ADD_EVENT_BRACKET_DUNGEONS';
const REMOVE_EVENT_BRACKET_DUNGEON = 'EVENTS_MANAGEMENT/REMOVE_EVENT_BRACKET_DUNGEON';
const EDIT_EVENT_BRACKET_DUNGEON = 'EVENTS_MANAGEMENT/EDIT_EVENT_BRACKET_DUNGEON';
const ADD_EVENT_BRACKET_TEAM = 'EVENTS_MANAGEMENT/ADD_EVENT_BRACKET_TEAM';
const REMOVE_EVENT_BRACKET_TEAM = 'EVENTS_MANAGEMENT/REMOVE_EVENT_BRACKET_TEAM';
const CHECK_IN_EVENT_BRACKET_TEAM = 'EVENTS_MANAGEMENT/CHECK_IN_EVENT_BRACKET_TEAM';
const CHECK_OUT_EVENT_BRACKET_TEAM = 'EVENTS_MANAGEMENT/CHECK_OUT_EVENT_BRACKET_TEAM';
const EDIT_EVENT_BRACKET_MATCH_DETAILS = 'EVENTS_MANAGEMENT/EDIT_EVENT_BRACKET_MATCH_DETAILS';
const ADD_EVENT_BRACKET_MATCH_ADDITIONAL_GAME = 'EVENTS_MANAGEMENT/ADD_EVENT_BRACKET_MATCH_ADDITIONAL_GAME';
const REMOVE_EVENT_BRACKET_MATCH_ADDITIONAL_GAME = 'EVENTS_MANAGEMENT/REMOVE_EVENT_BRACKET_MATCH_ADDITIONAL_GAME';
const EDIT_EVENT_BRACKET_MATCH_GAME_DETAILS = 'EVENTS_MANAGEMENT/EDIT_EVENT_BRACKET_MATCH_GAME_DETAILS';
const EDIT_EVENT_BRACKET_TEAM_POINTS = 'EVENTS_MANAGEMENT/EDIT_EVENT_BRACKET_TEAM_POINTS';
const EDIT_EVENT_BRACKET_TEAM = 'EDIT_EVENT_BRACKET_TEAM';
const BATCH_UPDATE_BRACKET_TEAMS = 'BATCH_UPDATE_BRACKET_TEAMS';
const ADD_EVENT_BRACKET_PLACEHOLDERS = 'EVENTS_MANAGEMENT/ADD_EVENT_BRACKET_PLACEHOLDERS';
const DELETE_EVENT_BRACKET_PLACEHOLDERS = 'EVENTS_MANAGEMENT/DELETE_EVENT_BRACKET_PLACEHOLDERS';
const EXPORT_CSV = 'EXPORT_CSV_LOADING';
const EXPORT_CSV_SUCCESS = 'EXPORT_CSV_SUCCESS';
const EXPORT_CSV_FAILURE = 'EXPORT_CSV_FAILURE';

const SET_REQUEST_PENDING = 'EVENTS_MANAGEMENT/SET_REQUEST_PENDING';
const SET_RENAME_BRACKET_TEAM = 'SET_RENAME_BRACKET_TEAM';

const LOAD_EVENT_LIST = 'EVENTS_MANAGEMENT/LOAD_EVENT_LIST';
const LOAD_EVENT_COLLECTION_LIST = 'EVENTS_MANAGEMENT/LOAD_EVENT_COLLECTION_LIST';
const LOAD_EVENT_DETAILS = 'EVENTS_MANAGEMENT/LOAD_EVENT_DETAILS';
const LOAD_EVENT_COLLECTION_DETAILS = 'EVENTS_MANAGEMENT/LOAD_EVENT_COLLECTION_DETAILS';
const LOAD_EVENT_REGISTRATION_STATIC_DATA = 'EVENTS_MANAGEMENT/LOAD_EVENT_REGISTRATION_STATIC_DATA';
const LOAD_EVENT_BRACKET_LIST = 'EVENTS_MANAGEMENT/LOAD_EVENT_BRACKET_LIST';
const LOAD_EVENT_BRACKET_PREVIEW_DETAILS = 'EVENTS_MANAGEMENT/LOAD_EVENT_BRACKET_PREVIEW_DETAILS';
const LOAD_EVENT_BRACKET_DETAILS = 'EVENTS_MANAGEMENT/LOAD_EVENT_BRACKET_DETAILS';
const LOAD_EVENT_BRACKET_TEAM_LIST = 'EVENTS_MANAGEMENT/LOAD_EVENT_BRACKET_TEAM_LIST';
const LOAD_EVENT_BRACKET_MATCHES = 'EVENTS_MANAGEMENT/LOAD_EVENT_BRACKET_MATCHES';
const LOAD_EVENT_BRACKET_MATCH_DETAILS = 'EVENTS_MANAGEMENT/LOAD_EVENT_BRACKET_MATCH_DETAILS';
const LOAD_EVENT_BRACKET_MATCH_GAMES = 'EVENTS_MANAGEMENT/LOAD_EVENT_BRACKET_MATCH_GAMES';
const LOAD_EVENT_BRACKET_MATCH_GAME_DETAILS = 'EVENTS_MANAGEMENT/LOAD_EVENT_BRACKET_MATCH_GAME_DETAILS';
const DEBUG_SELF_REPORT_SCORES = 'EVENTS_MANAGEMENT/DEBUG_SELF_REPORT_SCORES';

// Actions
export const getEventList = (params: TGetEventListDataParams) => {
  return {
    type: GET_EVENT_LIST,
    payload: params
  };
};

export const getEventCollectionList = (params: TGetEventCollectionListParams) => {
  return {
    type: GET_EVENT_COLLECTION_LIST,
    payload: params
  };
};

const getEventRegistrationStaticData = () => {
  return {
    type: GET_EVENT_REGISTRATION_STATIC_DATA
  };
};

const getEventDetails = (eventSlug: string) => {
  return {
    type: GET_EVENT_DETAILS,
    payload: {
      eventSlug
    }
  };
};

const getEventCollectionDetails = (params: TGetEventCollectionDetailsParams) => {
  return {
    type: GET_EVENT_COLLECTION_DETAILS,
    payload: params
  };
};

export const getEventManagementBracketList = (eventSlug: string) => {
  return {
    type: GET_EVENT_BRACKET_LIST,
    payload: {
      eventSlug
    }
  };
};

const getEventBracketDetails = (eventSlug: string, bracketSlug: string) => {
  return {
    type: GET_EVENT_BRACKET_DETAILS,
    payload: {
      eventSlug,
      bracketSlug
    }
  };
};

const getEventBracketPreviewDetails = (eventSlug: string, bracketSlug: string) => {
  return {
    type: GET_EVENT_BRACKET_PREVIEW_DETAILS,
    payload: {
      eventSlug,
      bracketSlug
    }
  };
};

const getEventBracketTeamList = (eventSlug: string, bracketSlug: string, filters: TGetBracketTeamListFilters) => {
  return {
    type: GET_EVENT_BRACKET_TEAM_LIST,
    payload: {
      eventSlug,
      bracketSlug,
      filters
    }
  };
};

const getEventBracketMatches = (eventSlug: string, bracketSlug: string) => {
  return {
    type: GET_EVENT_BRACKET_MATCHES,
    payload: {
      eventSlug,
      bracketSlug
    }
  };
};

const getEventBracketMatchDetails = (eventSlug: string, bracketSlug: string, matchId: number) => {
  return {
    type: GET_EVENT_BRACKET_MATCH_DETAILS,
    payload: {
      eventSlug,
      bracketSlug,
      matchId
    }
  };
};

const getEventBracketMatchGames = (eventSlug: string, bracketSlug: string, matchId: number) => {
  return {
    type: GET_EVENT_BRACKET_MATCH_GAMES,
    payload: {
      eventSlug,
      bracketSlug,
      matchId
    }
  };
};

const getEventBracketMatchGameDetails = (eventSlug: string, bracketSlug: string, matchId: number, gameId: number) => {
  return {
    type: GET_EVENT_BRACKET_MATCH_GAME_DETAILS,
    payload: {
      eventSlug,
      bracketSlug,
      matchId,
      gameId
    }
  };
};

const refreshEventManagementBracketList = (eventSlug: string, params: any) => {
  return {
    type: REFRESH_EVENT_BRACKET_LIST,
    payload: {
      eventSlug,
      params
    }
  };
};

const refreshEventBracketTeamList = (eventSlug: string, bracketSlug: string, filters: TGetBracketTeamListFilters) => {
  return {
    type: REFRESH_EVENT_BRACKET_TEAM_LIST,
    payload: {
      eventSlug,
      bracketSlug,
      filters
    }
  };
};

const refreshEventBracketPreviewDetails = (eventSlug: string, bracketSlug: string, params: any) => {
  return {
    type: REFRESH_EVENT_BRACKET_PREVIEW_DETAILS,
    payload: {
      eventSlug,
      bracketSlug,
      params
    }
  };
};

const refreshEventBracketMatches = (eventSlug: string, bracketSlug: string) => {
  return {
    type: REFRESH_EVENT_BRACKET_MATCHES,
    payload: {
      eventSlug,
      bracketSlug
    }
  };
};

const refreshEventBracketMatchDetails = (eventSlug: string, bracketSlug: string, matchId: number, params: any) => {
  return {
    type: REFRESH_EVENT_BRACKET_MATCH_DETAILS,
    payload: {
      eventSlug,
      bracketSlug,
      matchId,
      params
    }
  };
};

const refreshEventBracketMatchGames = (eventSlug: string, bracketSlug: string, matchId: number, params: any) => {
  return {
    type: REFRESH_EVENT_BRACKET_MATCH_GAMES,
    payload: {
      eventSlug,
      bracketSlug,
      matchId,
      params
    }
  };
};

const refreshEventBracketMatchGameDetails = (
  eventSlug: string,
  bracketSlug: string,
  matchId: number,
  gameId: number,
  params: any
) => {
  return {
    type: REFRESH_EVENT_BRACKET_MATCH_GAME_DETAILS,
    payload: {
      eventSlug,
      bracketSlug,
      matchId,
      gameId,
      params
    }
  };
};

const createEvent = (payload: TEventBodyPayload) => {
  return {
    type: CREATE_EVENT,
    payload
  };
};

const createLegacyEvent = (payload: TLegacyEventParams) => {
  return {
    type: CREATE_LEGACY_EVENT,
    payload
  };
};

const editEvent = (slug: string, params: TEventBodyPayload) => {
  return {
    type: EDIT_EVENT,
    payload: {
      slug,
      params
    }
  };
};

const editLegacyEvent = (slug: string, params: TLegacyEventParams) => {
  return {
    type: EDIT_LEGACY_EVENT,
    payload: {
      slug,
      params
    }
  };
};

const toggleLockEvent = (slug: string) => {
  return {
    type: TOGGLE_LOCK_EVENT,
    payload: {
      slug
    }
  };
};

const removeEvent = (slug: string) => {
  return {
    type: REMOVE_EVENT,
    payload: {
      slug
    }
  };
};

const copyEvent = (slug: string) => {
  return {
    type: COPY_EVENT,
    payload: {
      slug
    }
  };
};

const addCollaborator = (slug: string, collaborator: IEventCollaboratorSummary) => {
  return {
    type: ADD_EVENT_COLLABORATOR,
    payload: {
      slug,
      collaborator
    }
  };
};

const removeCollaborator = (slug: string, collaborator: IEventCollaboratorSummary) => {
  return {
    type: REMOVE_EVENT_COLLABORATOR,
    payload: {
      slug,
      collaborator
    }
  };
};

const addSpecRestriction = (eventSlug: string, bracketSlug: string, payload: TEventSpecRestrictionPayload) => {
  return {
    type: ADD_BRACKET_SPEC_RESTRICTION,
    payload: {
      eventSlug,
      bracketSlug,
      payload
    }
  };
};

const removeSpecRestriction = (eventSlug: string, bracketSlug: string, specIds: number[]) => {
  return {
    type: REMOVE_BRACKET_SPEC_RESTRICTION,
    payload: {
      eventSlug,
      bracketSlug,
      specIds
    }
  };
};

const addReplayRestriction = (eventSlug: string, bracketSlug: string, payload: TEventReplayRestrictionPayload) => {
  return {
    type: ADD_BRACKET_REPLAY_RESTRICTION,
    payload: {
      eventSlug,
      bracketSlug,
      payload
    }
  };
};

const removeReplayRestriction = (eventSlug: string, bracketSlug: string, restrictionId: number) => {
  return {
    type: REMOVE_BRACKET_REPLAY_RESTRICTION,
    payload: {
      eventSlug,
      bracketSlug,
      restrictionId
    }
  };
};

const getEventVideos = (payload: TGetEventVideosQueryParams) => {
  return {
    type: GET_EVENT_VIDEOS,
    payload
  };
};

const setEventVideosListState = (payload: TEventVideosListState) => {
  return {
    type: SET_EVENT_VIDEOS_LIST_STATE,
    payload
  };
};

const updateEventVideosListState = (payload: Partial<TEventVideosListState>) => {
  return {
    type: UPDATE_EVENT_VIDEOS_LIST_STATE,
    payload
  };
};

const updateEventVideos = (payload: TUpdateEventVideosParams) => {
  return {
    type: UPDATE_EVENT_VIDEOS,
    payload
  };
};

const addEventVideo = (payload: TAddEventVideoParams) => {
  return {
    type: ADD_EVENT_VIDEO,
    payload
  };
};

const editEventVideo = (id: number, payload: TEditEventVideoParams) => {
  return {
    type: EDIT_EVENT_VIDEO,
    payload: {
      id,
      params: payload
    }
  };
};

const removeEventVideo = (payload: TRemoveEventVideoParams) => {
  return {
    type: REMOVE_EVENT_VIDEO,
    payload
  };
};

const unlinkFinalEventVideo = (payload: TRemoveEventVideoParams) => {
  return {
    type: UNLINK_FINAL_EVENT_VIDEO,
    payload
  };
};

const createEventBracket = (eventSlug: string, payload: TEventBracketPayload) => {
  return {
    type: CREATE_EVENT_BRACKET,
    payload: {
      eventSlug,
      payload
    }
  };
};

const addEventToEventCollection = (collectionId: number, eventSlug: string) => {
  return {
    type: ADD_EVENT_TO_EVENT_COLLECTION,
    payload: {
      collectionId,
      eventSlug
    }
  };
};

const removeEventFromEventCollection = (collectionId: number, eventSlug: string) => {
  return {
    type: REMOVE_EVENT_FROM_EVENT_COLLECTION,
    payload: {
      collectionId,
      eventSlug
    }
  };
};

const addMultipleEventsToEventCollection = (collectionId: number, eventSlugs: string[]) => {
  return {
    type: ADD_MULTIPLE_EVENTS_TO_EVENT_COLLECTION,
    payload: {
      collectionId,
      eventSlugs
    }
  };
};

const removeMultipleEventsFromEventCollection = (collectionId: number, eventSlugs: string[]) => {
  return {
    type: REMOVE_MULTIPLE_EVENTS_FROM_EVENT_COLLECTION,
    payload: {
      collectionId,
      eventSlugs
    }
  };
};

const createEventCollection = (payload: TCreateEventCollectionParams) => {
  return {
    type: CREATE_EVENT_COLLECTION,
    payload
  };
};

const deleteEventCollection = (payload: TDeleteEventCollectionParams) => {
  return {
    type: DELETE_EVENT_COLLECTION,
    payload
  };
};

const editEventCollection = (payload: TEditEventCollectionParams) => {
  return {
    type: EDIT_EVENT_COLLECTION,
    payload
  };
};

const addCollectionWinner = (payload: TAddCollectionWinnerParams) => {
  return {
    type: ADD_COLLECTION_WINNER,
    payload
  };
};

const editCollectionWinner = (payload: TEditCollectionWinnerParams) => {
  return {
    type: EDIT_COLLECTION_WINNER,
    payload
  };
};

const removeCollectionWinner = (payload: TRemoveCollectionWinnerParams) => {
  return {
    type: REMOVE_COLLECTION_WINNER,
    payload
  };
};

const addEventWinner = (payload: TAddEventWinnerParams) => {
  return {
    type: ADD_EVENT_WINNER,
    payload
  };
};

const editEventWinner = (payload: TEditEventWinnerParams) => {
  return {
    type: EDIT_EVENT_WINNER,
    payload
  };
};

const removeEventWinner = (payload: TRemoveEventWinnerParams) => {
  return {
    type: REMOVE_EVENT_WINNER,
    payload
  };
};

const editEventBracket = (eventSlug: string, bracketSlug: string, payload: TEventBracketPayload) => {
  return {
    type: EDIT_EVENT_BRACKET,
    payload: {
      eventSlug,
      bracketSlug,
      payload
    }
  };
};

const removeEventBracket = (eventSlug: string, bracketSlug: string) => {
  return {
    type: REMOVE_EVENT_BRACKET,
    payload: {
      eventSlug,
      bracketSlug
    }
  };
};

const copyEventBracket = (eventSlug: string, bracketSlug: string) => {
  return {
    type: COPY_EVENT_BRACKET,
    payload: {
      eventSlug,
      bracketSlug
    }
  };
};
const addEventBracketDungeon = (eventSlug: string, bracketSlug: string, payload: TEventBracketDungeonPayload) => {
  return {
    type: ADD_EVENT_BRACKET_DUNGEON,
    payload: {
      eventSlug,
      bracketSlug,
      payload
    }
  };
};

const addEventBracketDungeons = (eventSlug: string, bracketSlug: string) => {
  return {
    type: ADD_EVENT_BRACKET_DUNGEONS,
    payload: {
      eventSlug,
      bracketSlug
    }
  };
};
const removeEventBracketDungeon = (eventSlug: string, bracketSlug: string, id: number) => {
  return {
    type: REMOVE_EVENT_BRACKET_DUNGEON,
    payload: {
      eventSlug,
      bracketSlug,
      id
    }
  };
};

const editEventBracketDungeon = (eventSlug: string, bracketSlug: string, payload: TEventBracketDungeonPayload) => {
  return {
    type: EDIT_EVENT_BRACKET_DUNGEON,
    payload: {
      eventSlug,
      bracketSlug,
      payload
    }
  };
};

const addEventBracketTeam = (eventSlug: string, bracketSlug: string, team: any) => {
  return {
    type: ADD_EVENT_BRACKET_TEAM,
    payload: {
      eventSlug,
      bracketSlug,
      team
    }
  };
};

const removeEventBracketTeam = (eventSlug: string, bracketSlug: string, team: any) => {
  return {
    type: REMOVE_EVENT_BRACKET_TEAM,
    payload: {
      eventSlug,
      bracketSlug,
      team
    }
  };
};

const editEventBracketTeam = (eventSlug: string, bracketSlug: string, payload: TUpdateBracketTeamPayload) => {
  return {
    type: EDIT_EVENT_BRACKET_TEAM,
    payload: {
      eventSlug,
      bracketSlug,
      payload
    }
  };
};

const batchUpdateBracketTeams = (eventSlug: string, bracketSlug: string, payload: TBatchUpdateBracketTeamsPayload) => {
  return {
    type: BATCH_UPDATE_BRACKET_TEAMS,
    payload: {
      eventSlug,
      bracketSlug,
      payload
    }
  };
};

const checkInEventBracketTeam = (eventSlug: string, bracketSlug: string, bracketTeamId: number) => {
  return {
    type: CHECK_IN_EVENT_BRACKET_TEAM,
    payload: {
      eventSlug,
      bracketSlug,
      bracketTeamId
    }
  };
};

const checkOutEventBracketTeam = (eventSlug: string, bracketSlug: string, bracketTeamId: number) => {
  return {
    type: CHECK_OUT_EVENT_BRACKET_TEAM,
    payload: {
      eventSlug,
      bracketSlug,
      bracketTeamId
    }
  };
};

const editEventBracketMatchDetails = (
  eventSlug: string,
  bracketSlug: string,
  matchId: number,
  payload: TEventBracketMatchPayload
) => {
  return {
    type: EDIT_EVENT_BRACKET_MATCH_DETAILS,
    payload: {
      eventSlug,
      bracketSlug,
      matchId,
      payload
    }
  };
};

const addEventBracketMatchPlaceholders = (eventSlug: string, bracketSlug: string) => {
  return {
    type: ADD_EVENT_BRACKET_PLACEHOLDERS,
    payload: {
      eventSlug,
      bracketSlug
    }
  };
};

const deleteEventBracketMatchPlaceholders = (eventSlug: string, bracketSlug: string) => {
  return {
    type: DELETE_EVENT_BRACKET_PLACEHOLDERS,
    payload: {
      eventSlug,
      bracketSlug
    }
  };
};

const addEventBracketMatchAdditionalGame = (eventSlug: string, bracketSlug: string, matchId: number) => {
  return {
    type: ADD_EVENT_BRACKET_MATCH_ADDITIONAL_GAME,
    payload: {
      eventSlug,
      bracketSlug,
      matchId
    }
  };
};

const removeEventBracketMatchAdditionalGame = (eventSlug: string, bracketSlug: string, matchId: number) => {
  return {
    type: REMOVE_EVENT_BRACKET_MATCH_ADDITIONAL_GAME,
    payload: {
      eventSlug,
      bracketSlug,
      matchId
    }
  };
};

const editEventBracketMatchGameDetails = (
  eventSlug: string,
  bracketSlug: string,
  matchId: number,
  gameId: number,
  payload: TEventBracketMatchGamePayload
) => {
  return {
    type: EDIT_EVENT_BRACKET_MATCH_GAME_DETAILS,
    payload: {
      eventSlug,
      bracketSlug,
      matchId,
      gameId,
      payload
    }
  };
};

const debugSelfReportScores = (params: any) => {
  return {
    type: DEBUG_SELF_REPORT_SCORES,
    payload: params
  };
};

const exportCsv = (slug: string) => {
  return {
    type: EXPORT_CSV,
    payload: {
      slug
    }
  };
};

const setRequestPending = (payload: boolean): TAction<Partial<TEventsManagementState>> => {
  return {
    type: SET_REQUEST_PENDING,
    payload: {
      requestPending: payload
    }
  };
};

const setEditBracketTeam = (payload: IEventBracketTeamDetails | null): TAction<Partial<TEventsManagementState>> => {
  return {
    type: SET_RENAME_BRACKET_TEAM,
    payload: { editBracketTeam: payload }
  };
};

const loadEventList = (payload: TEventListState): TAction<Partial<TEventsManagementState>> => {
  return {
    type: LOAD_EVENT_LIST,
    payload: {
      eventList: payload
    }
  };
};

const loadEventCollectionList = (payload: TEventCollectionListState): TAction<Partial<TEventsManagementState>> => {
  return {
    type: LOAD_EVENT_COLLECTION_LIST,
    payload: {
      eventCollectionList: payload
    }
  };
};

const loadEventDetails = (payload: TEventDetailsState): TAction<Partial<TEventsManagementState>> => {
  return {
    type: LOAD_EVENT_DETAILS,
    payload: {
      eventDetails: payload
    }
  };
};

const loadEventCollectionDetails = (
  payload: TEventCollectionDetailsState
): TAction<Partial<TEventsManagementState>> => {
  return {
    type: LOAD_EVENT_COLLECTION_DETAILS,
    payload: {
      eventCollectionDetails: payload
    }
  };
};

const loadEventRegistrationStaticData = (
  payload: TEventRegistrationStaticDataState
): TAction<Partial<TEventsManagementState>> => {
  return {
    type: LOAD_EVENT_REGISTRATION_STATIC_DATA,
    payload: {
      eventRegistrationStaticData: payload
    }
  };
};

export const loadEventBracketList = (
  payload: TEventBracketListManagementState
): TAction<Partial<TEventsManagementState>> => {
  return {
    type: LOAD_EVENT_BRACKET_LIST,
    payload: {
      eventBracketList: payload
    }
  };
};

const loadEventBracketDetails = (
  payload: TEventBracketDetailsManagementState
): TAction<Partial<TEventsManagementState>> => {
  return {
    type: LOAD_EVENT_BRACKET_DETAILS,
    payload: {
      eventBracketDetails: payload
    }
  };
};

const loadEventBracketPreviewDetails = (
  payload: TEventBracketDetailsPreviewState
): TAction<Partial<TEventsManagementState>> => {
  return {
    type: LOAD_EVENT_BRACKET_PREVIEW_DETAILS,
    payload: {
      eventBracketPreviewDetails: payload
    }
  };
};

const loadEventBracketTeamList = (payload: TEventBracketTeamListState): TAction<Partial<TEventsManagementState>> => {
  return {
    type: LOAD_EVENT_BRACKET_TEAM_LIST,
    payload: {
      eventBracketTeamList: payload
    }
  };
};

const loadEventBracketMatches = (payload: TEventBracketMatchesState): TAction<Partial<TEventsManagementState>> => {
  return {
    type: LOAD_EVENT_BRACKET_MATCHES,
    payload: {
      eventBracketMatches: payload
    }
  };
};

const loadEventBracketMatchDetails = (
  payload: TEventBracketMatchDetailsState
): TAction<Partial<TEventsManagementState>> => {
  return {
    type: LOAD_EVENT_BRACKET_MATCH_DETAILS,
    payload: {
      eventBracketMatchDetails: payload
    }
  };
};

const loadEventBracketMatchGames = (
  payload: TEventBracketMatchGamesState
): TAction<Partial<TEventsManagementState>> => {
  return {
    type: LOAD_EVENT_BRACKET_MATCH_GAMES,
    payload: {
      eventBracketMatchGames: payload
    }
  };
};

const loadEventBracketMatchGameDetails = (
  payload: TEventBracketMatchGameDetailsState
): TAction<Partial<TEventsManagementState>> => {
  return {
    type: LOAD_EVENT_BRACKET_MATCH_GAME_DETAILS,
    payload: {
      eventBracketMatchGameDetails: payload
    }
  };
};

export function reducer(
  state: TEventsManagementState = getInitialState(),
  action: TAction<any>
): TEventsManagementState {
  switch (action.type) {
    case SET_RENAME_BRACKET_TEAM:
    case SET_REQUEST_PENDING:
    case LOAD_EVENT_LIST:
    case LOAD_EVENT_COLLECTION_LIST:
    case SET_EVENT_VIDEOS_LIST_STATE:
    case LOAD_EVENT_DETAILS:
    case LOAD_EVENT_COLLECTION_DETAILS:
    case LOAD_EVENT_REGISTRATION_STATIC_DATA:
    case LOAD_EVENT_BRACKET_LIST:
    case LOAD_EVENT_BRACKET_DETAILS:
    case LOAD_EVENT_BRACKET_PREVIEW_DETAILS:
    case LOAD_EVENT_BRACKET_TEAM_LIST:
    case LOAD_EVENT_BRACKET_MATCHES:
    case LOAD_EVENT_BRACKET_MATCH_DETAILS:
    case LOAD_EVENT_BRACKET_MATCH_GAMES:
    case LOAD_EVENT_BRACKET_MATCH_GAME_DETAILS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case UPDATE_EVENT_VIDEOS_LIST_STATE: {
      return {
        ...state,
        eventVideosList: {
          ...state.eventVideosList,
          ...action.payload
        }
      };
    }
    default:
      return state;
  }
}

export const actions = {
  getEventList,
  getEventCollectionList,
  getEventDetails,
  getEventCollectionDetails,
  getEventRegistrationStaticData,
  getEventManagementBracketList,
  getEventBracketDetails,
  getEventBracketPreviewDetails,
  getEventBracketTeamList,
  getEventBracketMatches,
  getEventBracketMatchDetails,
  getEventBracketMatchGames,
  getEventBracketMatchGameDetails,

  refreshEventManagementBracketList,
  refreshEventBracketTeamList,
  refreshEventBracketMatches,
  refreshEventBracketMatchDetails,
  refreshEventBracketMatchGames,
  refreshEventBracketMatchGameDetails,
  refreshEventBracketPreviewDetails,

  createEvent,
  createLegacyEvent,
  editEvent,
  editLegacyEvent,
  removeEvent,
  copyEvent,
  toggleLockEvent,
  addCollaborator,
  removeCollaborator,
  addSpecRestriction,
  addReplayRestriction,
  getEventVideos,
  updateEventVideos,
  updateEventVideosListState,
  setEventVideosListState,
  addEventVideo,
  editEventVideo,
  unlinkFinalEventVideo,
  removeEventVideo,
  removeSpecRestriction,
  removeReplayRestriction,
  addEventToEventCollection,
  removeEventFromEventCollection,
  addMultipleEventsToEventCollection,
  removeMultipleEventsFromEventCollection,
  deleteEventCollection,
  createEventCollection,
  editEventCollection,
  addCollectionWinner,
  editCollectionWinner,
  removeCollectionWinner,
  addEventWinner,
  editEventWinner,
  removeEventWinner,
  createEventBracket,
  editEventBracket,
  removeEventBracket,
  copyEventBracket,
  addEventBracketDungeon,
  addEventBracketDungeons,
  addEventBracketMatchPlaceholders,
  deleteEventBracketMatchPlaceholders,
  editEventBracketDungeon,
  removeEventBracketDungeon,
  addEventBracketTeam,
  removeEventBracketTeam,
  checkInEventBracketTeam,
  checkOutEventBracketTeam,
  editEventBracketMatchDetails,
  removeEventBracketMatchAdditionalGame,
  addEventBracketMatchAdditionalGame,
  editEventBracketMatchGameDetails,
  editEventBracketTeam,
  batchUpdateBracketTeams,

  exportCsv,

  setRequestPending,
  setEditBracketTeam,

  loadEventList,
  loadEventCollectionList,
  loadEventDetails,
  loadEventCollectionDetails,
  loadEventRegistrationStaticData,
  loadEventBracketList,
  loadEventBracketDetails,
  loadEventBracketPreviewDetails,
  loadEventBracketTeamList,
  loadEventBracketMatches,
  loadEventBracketMatchDetails,
  loadEventBracketMatchGames,
  loadEventBracketMatchGameDetails,

  debugSelfReportScores
};

export const actionTypes = {
  GET_EVENT_LIST,
  GET_EVENT_COLLECTION_LIST,
  GET_EVENT_COLLECTION_DETAILS,
  GET_EVENT_DETAILS,
  GET_EVENT_REGISTRATION_STATIC_DATA,
  GET_EVENT_BRACKET_LIST,
  GET_EVENT_BRACKET_PREVIEW_DETAILS,
  GET_EVENT_BRACKET_DETAILS,
  GET_EVENT_BRACKET_TEAM_LIST,
  GET_EVENT_BRACKET_MATCHES,
  GET_EVENT_BRACKET_MATCH_DETAILS,
  GET_EVENT_BRACKET_MATCH_GAMES,
  GET_EVENT_BRACKET_MATCH_GAME_DETAILS,

  REFRESH_EVENT_BRACKET_LIST,
  REFRESH_EVENT_BRACKET_TEAM_LIST,
  REFRESH_EVENT_BRACKET_MATCHES,
  REFRESH_EVENT_BRACKET_MATCH_DETAILS,
  REFRESH_EVENT_BRACKET_MATCH_GAMES,
  REFRESH_EVENT_BRACKET_MATCH_GAME_DETAILS,
  REFRESH_EVENT_BRACKET_PREVIEW_DETAILS,

  CREATE_EVENT,
  CREATE_LEGACY_EVENT,
  EDIT_EVENT,
  EDIT_LEGACY_EVENT,
  REMOVE_EVENT,
  COPY_EVENT,
  TOGGLE_LOCK_EVENT,
  ADD_EVENT_COLLABORATOR,
  REMOVE_EVENT_COLLABORATOR,
  ADD_BRACKET_SPEC_RESTRICTION,
  REMOVE_BRACKET_SPEC_RESTRICTION,
  ADD_BRACKET_REPLAY_RESTRICTION,
  REMOVE_BRACKET_REPLAY_RESTRICTION,
  GET_EVENT_VIDEOS,
  ADD_EVENT_VIDEO,
  EDIT_EVENT_VIDEO,
  SET_EVENT_VIDEOS_LIST_STATE,
  UPDATE_EVENT_VIDEOS_LIST_STATE,
  UPDATE_EVENT_VIDEOS,
  REMOVE_EVENT_VIDEO,
  UNLINK_FINAL_EVENT_VIDEO,
  CREATE_EVENT_BRACKET,
  EDIT_EVENT_BRACKET,
  REMOVE_EVENT_BRACKET,
  COPY_EVENT_BRACKET,
  ADD_EVENT_BRACKET_DUNGEON,
  ADD_EVENT_BRACKET_DUNGEONS,
  REMOVE_EVENT_BRACKET_DUNGEON,
  EDIT_EVENT_BRACKET_DUNGEON,
  ADD_EVENT_TO_EVENT_COLLECTION,
  REMOVE_EVENT_FROM_EVENT_COLLECTION,
  ADD_MULTIPLE_EVENTS_TO_EVENT_COLLECTION,
  REMOVE_MULTIPLE_EVENTS_FROM_EVENT_COLLECTION,
  CREATE_EVENT_COLLECTION,
  EDIT_EVENT_COLLECTION,
  ADD_COLLECTION_WINNER,
  EDIT_COLLECTION_WINNER,
  REMOVE_COLLECTION_WINNER,
  ADD_EVENT_WINNER,
  EDIT_EVENT_WINNER,
  REMOVE_EVENT_WINNER,
  ADD_EVENT_BRACKET_TEAM,
  REMOVE_EVENT_BRACKET_TEAM,
  CHECK_IN_EVENT_BRACKET_TEAM,
  CHECK_OUT_EVENT_BRACKET_TEAM,
  EDIT_EVENT_BRACKET_MATCH_DETAILS,
  REMOVE_EVENT_BRACKET_MATCH_ADDITIONAL_GAME,
  ADD_EVENT_BRACKET_MATCH_ADDITIONAL_GAME,
  EDIT_EVENT_BRACKET_MATCH_GAME_DETAILS,
  EDIT_EVENT_BRACKET_TEAM_POINTS,
  BATCH_UPDATE_BRACKET_TEAMS,
  EDIT_EVENT_BRACKET_TEAM,
  DELETE_EVENT_COLLECTION,
  ADD_EVENT_BRACKET_PLACEHOLDERS,
  DELETE_EVENT_BRACKET_PLACEHOLDERS,

  EXPORT_CSV,
  EXPORT_CSV_SUCCESS,
  EXPORT_CSV_FAILURE,

  SET_REQUEST_PENDING,

  LOAD_EVENT_LIST,
  LOAD_EVENT_COLLECTION_LIST,
  LOAD_EVENT_DETAILS,
  LOAD_EVENT_REGISTRATION_STATIC_DATA,
  LOAD_EVENT_BRACKET_LIST,
  LOAD_EVENT_BRACKET_DETAILS,
  LOAD_EVENT_BRACKET_TEAM_LIST,
  LOAD_EVENT_BRACKET_MATCHES,
  LOAD_EVENT_BRACKET_MATCH_DETAILS,
  LOAD_EVENT_BRACKET_MATCH_GAMES,
  LOAD_EVENT_BRACKET_MATCH_GAME_DETAILS,

  DEBUG_SELF_REPORT_SCORES
};
